module.exports = __webpack_public_path__ + "img/annotation-comment.4f3d3d9b.svg";